import { navigation } from './navigation';
import { forms } from './forms';
import { multiCarousel } from './multiCarousel';

const Collapse = () => {
    const returnObj = {};

    /**
     * all collapse click event set a new class "active" or remove it
     */
    returnObj.collapseActiveEvent = function () {
        returnObj.collapseChangeClass('show.bs.collapse', 'active');
        returnObj.collapseChangeClass('hidden.bs.collapse', 'active');
    };

    /**
     * Change the class from clicked element
     *
     * @param event
     * @param elClass
     */
    returnObj.collapseChangeClass = function (event, elClass) {
        jQuery(document).on(event, '.collapse', function (e) {
            var hasTargetClass = e.currentTarget.classList.contains('xs-mainnav');
            var targetClass = hasTargetClass ? 'xs-mainnav' : e.currentTarget.classList[0];
            var clickEl = jQuery('[data-bs-target=".' + targetClass + '"]');
            jQuery('.address .show, .payment .show').removeClass('show');

            returnObj.collapseCaret(event, clickEl);
            clickEl.toggleClass(elClass);
            if (hasTargetClass === true) {
                navigation.xsNavigation();
                if (event === 'hidden.bs.collapse') {
                    // reset the xs-mainnav
                    navigation.resetNav(false, false);
                }
            }
            returnObj.collapseChangeIcon(clickEl);
        });

        jQuery('.collapse').on('shown.bs.collapse', () => {
            forms.clearInputButton();
            returnObj.carouselMultiInit();
        })
    };

    returnObj.collapseCaret = function (event, el) {
        if (event === 'hidden.bs.collapse') {
            jQuery(el).find('.nav-caret').addClass('hidden');
        }

        if (event === 'show.bs.collapse') {
            jQuery(el).find('.nav-caret').removeClass('hidden');
        }
    }

    /**
     * Change the icon of the clicked element
     *
     * @param el
     */
    returnObj.collapseChangeIcon = function (el) {
        jQuery(el).children('.js-icon').each(function () {
            jQuery(this).toggleClass('hidden');
        })
    };

    /**
     * init carouselmulti items to calculate numbers of items on available width
     */
    returnObj.carouselMultiInit = function () {
        multiCarousel.init();
    };

    // initial action
    returnObj.collapseActiveEvent();

    return returnObj;
}
export const collapse = Collapse();
